import styled from 'styled-components';
import { FontSize, inputStyle, spacing } from 'commons';

export const Main = styled.div<{ $isEnable: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 24px;
  border-radius: 8px;
  padding: 24px;
  border: 1px solid ${({ theme }) => theme.neutral_300};
  background-color: ${({ theme }) => theme.neutral_100};

  ${({ $isEnable, theme }) =>
    $isEnable && `border-color: ${theme.neutral_500};`}
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  width: fit-content;
  gap: 8px;
  cursor: pointer;
`;

export const LabelWrapper = styled.label`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const ProductForm = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
  min-width: 280px;
`;

export const Textarea = styled.textarea`
  resize: vertical;
  min-height: ${spacing.input.height};
  border-radius: ${spacing.input.borderRadius};
  border: 1px solid ${({ theme }) => theme.neutral_500};
  font-size: ${FontSize.font12};
  font-weight: ${inputStyle.fontWeight};
  padding: 16px;
  color: ${({ theme }) => theme.neutral_500};

  &::placeholder {
    opacity: ${inputStyle.placeholderOpacity};
  }

  &:disabled {
    cursor: not-allowed;
    pointer-events: none;
    border-color: ${({ theme }) => theme.neutral_300};
    background-color: ${({ theme }) => theme.neutral_200};
    color: ${({ theme }) => theme.neutral_300};
  }
`;
